import { sortChronologically } from "../../helper/utils";
import { HistoryState } from "./HistoryState";
import { NQRecord } from "./types";

export const getAllRecords = (state: HistoryState): NQRecord[] =>  sortChronologically(state.records);